import Vue from "vue";
import VueAnime from "vue-animejs";

// https://github.com/BenAHammond/vue-anime
// https://animejs.com/documentation/#pennerFunctions
Vue.use(VueAnime);
